module.exports = {"140403001":"东街街道","140403002":"西街街道","140403003":"英雄南路街道","140403004":"英雄中路街道","140403005":"紫金街街道","140403006":"太行东街街道","140403007":"太行西街街道","140403008":"延安南路街道","140403009":"常青街道","140403010":"五马街道","140403013":"堠北庄街道","140403014":"老顶山街道","140403015":"大辛庄街道","140403103":"马厂镇","140403104":"黄碾镇","140403105":"西白兔镇","140403400":"长治市漳泽工业转型试验区管理委员会社区","140403401":"长治市老顶山旅游开发管理中心","140403403":"长治经济技术开发区潞州区部分"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140403.json
// module id = 378
// module chunks = 0